import { render, staticRenderFns } from "./RatingRecordList.vue?vue&type=template&id=8e56df94&scoped=true&"
import script from "./RatingRecordList.vue?vue&type=script&lang=js&"
export * from "./RatingRecordList.vue?vue&type=script&lang=js&"
import style0 from "./RatingRecordList.vue?vue&type=style&index=0&id=8e56df94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e56df94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VList,VListItem,VListItemContent,VPagination,VRow})
